import { render } from "./PhotoAlbumCreate.vue?vue&type=template&id=3197de08&ts=true"
import script from "./PhotoAlbumCreate.vue?vue&type=script&lang=ts"
export * from "./PhotoAlbumCreate.vue?vue&type=script&lang=ts"

import exportComponent from "/data/home/cazaleres/application/cazaleres-owner/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__